module.exports = __webpack_public_path__ + "img/real-example.c583007.webp";